module.exports = __webpack_public_path__ + "static/media/hitpaw-video-editor-box.37ed9186.png";